import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { LegalPage } from "../components/LegalPage.tsx";

const intro = [
  "Definitieve versie • geldig voor nieuwe reserveringen vanaf 1 oktober 2026",
  "Pippaya Hondenopvang • Boezem 7, Giessenburg • KvK 96754974",
  "Deze algemene voorwaarden gelden voor opvangovereenkomsten tussen Pippaya Hondenopvang en de eigenaar van de hond. Met 'eigenaar' wordt in deze voorwaarden ook bedoeld degene die bevoegd is namens de eigenaar afspraken over de hond te maken."
];

const sections = [
  {
    heading: "Ingangsdatum en bestaande reserveringen",
    items: [
        "Deze Algemene Voorwaarden zijn van toepassing op nieuwe reserveringen die vanaf 1 oktober 2026 definitief worden gemaakt.",
        "Voor reserveringen die vóór 1 oktober 2026 definitief zijn gemaakt, blijven de Algemene Voorwaarden en afspraken gelden die op het moment van die reservering van toepassing waren."
    ]
  },
  {
    heading: "1. Kennismaking en toelating",
    items: [
        "Voor een eerste verblijf vindt in principe vooraf een kennismaking plaats. Pippaya Hondenopvang beoordeelt of de hond past binnen de kleinschalige opvang en kijkt daarbij onder andere naar gedrag, omgang met mensen en andere honden en de samenstelling van de groep.",
        "Een goed verlopen kennismaking geeft geen garantie dat ieder toekomstig verblijf automatisch mogelijk is. Gedrag, omstandigheden en groepssamenstelling kunnen veranderen. Pippaya Hondenopvang mag een reserveringsaanvraag weigeren wanneer er twijfel bestaat of de opvang voor de hond en de overige honden veilig en prettig kan verlopen.",
        "De eigenaar geeft vooraf alle informatie door die voor de opvang van belang kan zijn, waaronder bijzonderheden in gedrag, angst, agressie, bewaken van voer of spullen, ontsnappingsgedrag en eerder problematisch gedrag. Verandert er tussen de reservering en de aankomstdatum iets dat voor de opvang van belang is, dan meldt de eigenaar dit zo snel mogelijk."
    ]
  },
  {
    heading: "2. Boeking en definitieve reservering",
    items: [
        "Een aanvraag via de website, WhatsApp, e-mail, telefoon of een andere manier is nog geen definitieve reservering.",
        "Wanneer Pippaya Hondenopvang de opvang kan aanbieden, ontvangt de eigenaar een offerte. De reservering wordt definitief en bindend zodra de eigenaar deze offerte online heeft goedgekeurd. Met het online goedkeuren van de offerte gaat de eigenaar tevens akkoord met deze Algemene Voorwaarden en de daarin opgenomen annuleringsvoorwaarden.",
        "Pippaya Hondenopvang houdt bij het beoordelen van een aanvraag niet alleen rekening met beschikbare ruimte, maar ook met de honden die in de betreffende periode al in de opvang verblijven."
    ]
  },
  {
    heading: "3. Facturering en betaling",
    items: [
        "Na goedkeuring van de offerte is de reservering definitief.",
        "De factuur voor de volledige opvangsom wordt in principe ongeveer 6 weken vóór de eerste opvangdag verzonden.",
        "Wanneer een opvangperiode over de jaarwisseling heen loopt, wordt de opvang per kalenderjaar gefactureerd. Het gedeelte van de opvang dat in het lopende kalenderjaar plaatsvindt, wordt in dat kalenderjaar gefactureerd. Het gedeelte dat in het nieuwe kalenderjaar plaatsvindt, wordt vanaf 1 januari van het nieuwe kalenderjaar afzonderlijk gefactureerd.",
        "De betalingstermijn bedraagt 7 dagen na factuurdatum. Wanneer een opvangperiode of het betreffende gefactureerde gedeelte eerder eindigt, dient de factuur uiterlijk vóór het einde daarvan te zijn betaald.",
        "Wanneer een verschuldigde factuur tijdens een lopende opvangperiode niet binnen de geldende betalingstermijn is betaald, neemt Pippaya Hondenopvang contact op met de eigenaar. Indien betaling uitblijft, kan Pippaya Hondenopvang verlangen dat de hond door de eigenaar of de opgegeven achtervang wordt opgehaald."
    ]
  },
  {
    heading: "4. Annulering door de eigenaar",
    items: [
        "Na online goedkeuring van de offerte is de reservering definitief.",
        "Bij annulering door de eigenaar gelden de volgende annuleringskosten:",
        "• Meer dan 12 weken vóór de eerste opvangdag: €25 administratiekosten.",
        "• Tussen 12 en 6 weken vóór de eerste opvangdag: 50% van de afgesproken opvangsom.",
        "• Binnen 6 weken vóór de eerste opvangdag: 100% van de afgesproken opvangsom.",
        "• Niet verschijnen zonder annulering: 100% van de afgesproken opvangsom.",
        "Wanneer Pippaya Hondenopvang de vrijgekomen opvangperiode geheel of gedeeltelijk opnieuw kan invullen, wordt hiermee rekening gehouden bij het bepalen van de uiteindelijke annuleringskosten."
    ]
  },
  {
    heading: "5. Tarieven en breng- en ophaaltijden",
    items: [
        "De actuele tarieven worden vooraf bekendgemaakt via de website en/of de offerte.",
        "Voor dagopvang kan de hond vanaf 08.00 uur worden gebracht en wordt de hond vóór 18.00 uur opgehaald.",
        "Bij een verblijf met overnachting kan de hond op de eerste gereserveerde dag na 14.00 uur worden gebracht. Op de laatste gereserveerde dag wordt de hond vóór 10.00 uur opgehaald.",
        "Voor feestdagopvang geldt het daarvoor afgesproken feestdagtarief. Brengen kan vanaf 10.00 uur. Wanneer de feestdagopvang een overnachting omvat, wordt de hond de volgende ochtend vóór 10.00 uur opgehaald.",
        "Afwijkende breng- of ophaaltijden zijn alleen mogelijk na voorafgaand overleg en wanneer dit vooraf is afgesproken. Hiervoor kan € 5 per extra uur in rekening worden gebracht. Bij onaangekondigd later ophalen kan de extra tijd eveneens in rekening worden gebracht. Wanneer afgesproken tijden herhaaldelijk niet worden nagekomen, kan Pippaya Hondenopvang besluiten toekomstige reserveringen niet meer aan te nemen.",
        "Wanneer een hond op de afgesproken laatste dag niet wordt opgehaald en de eigenaar en achtervang niet bereikbaar zijn, worden de noodzakelijke extra opvangdagen en daarmee samenhangende kosten aan de eigenaar doorberekend. Pippaya Hondenopvang mag in dat geval maatregelen nemen die redelijkerwijs nodig zijn voor het welzijn en de verzorging van de hond."
    ]
  },
  {
    heading: "6. Voeding",
    items: [
        "De eigenaar brengt voldoende eigen voer mee voor de volledige opvangperiode. Pippaya Hondenopvang geeft dit voer volgens de afgesproken hoeveelheid en het gebruikelijke voedingsschema van de hond. Het meenemen van het eigen voer is verplicht om het normale voedingspatroon zoveel mogelijk te behouden en de kans op maag- en darmklachten door een plotselinge voerwissel te beperken.",
        "Wanneer door onvoorziene omstandigheden onvoldoende voer aanwezig is, neemt Pippaya Hondenopvang zo mogelijk contact op met de eigenaar. Moet aanvullend voer worden aangeschaft om de hond goed te kunnen blijven verzorgen, dan zijn deze kosten voor rekening van de eigenaar."
    ]
  },
  {
    heading: "7. Medicatie en extra verzorging",
    items: [
        "Gebruikelijke medicatie die eenvoudig bij een maaltijd of op een afgesproken moment kan worden gegeven, is inbegrepen in de normale opvang.",
        "Heeft een hond intensievere of meerdere dagelijkse verzorgingshandelingen nodig, bijvoorbeeld herhaald oog- of oordruppelen, wondverzorging of andere medische handelingen, dan kan hiervoor een extra vergoeding worden afgesproken. Dit wordt vooraf met de eigenaar besproken en overeengekomen."
    ]
  },
  {
    heading: "8. Gezondheid, vaccinaties en parasieten",
    items: [
        "Een hond die bij Pippaya Hondenopvang verblijft, moet gezond zijn en mag geen bekende besmettelijke aandoening hebben.",
        "De eigenaar zorgt voor geldige vaccinaties of een geldige titerbepaling. Daarnaast is een geldige vaccinatie tegen kennelhoest verplicht en moet deze kunnen worden aangetoond.",
        "De eigenaar neemt de gebruikelijke preventieve maatregelen tegen wormen, vlooien en teken en zorgt dat ontworming en vlooien-/tekenbehandeling tijdig plaatsvinden.",
        "Pippaya Hondenopvang mag een hond weigeren wanneer er duidelijke ziekteverschijnselen, een besmettelijke aandoening of parasieten worden geconstateerd, of wanneer niet aan de afgesproken vaccinatie-eisen wordt voldaan. Wanneer tijdens het verblijf behandeling tegen parasieten noodzakelijk blijkt, mag Pippaya Hondenopvang hiervoor passende maatregelen nemen. De kosten daarvan zijn voor rekening van de eigenaar."
    ]
  },
  {
    heading: "9. Ziekte, letsel en dierenarts",
    items: [
        "Wanneer een hond tijdens het verblijf ziek wordt, gewond raakt of andere gezondheidsklachten vertoont, beoordeelt Pippaya Hondenopvang welke actie op dat moment noodzakelijk is.",
        "Wanneer er naar het oordeel van Pippaya Hondenopvang sprake is van een spoedeisende situatie of mogelijk levensgevaar, staat het welzijn van de hond voorop. Pippaya Hondenopvang is in dat geval gerechtigd direct een dierenarts of dierenkliniek in te schakelen en noodzakelijke medische hulp te laten verlenen, zonder eerst toestemming van de eigenaar af te wachten.",
        "Pippaya Hondenopvang informeert de eigenaar zo spoedig mogelijk, maar het bereiken van de eigenaar mag noodzakelijke spoedeisende medische hulp niet vertragen.",
        "In een niet-spoedeisende situatie neemt Pippaya Hondenopvang eerst contact op met de eigenaar om te overleggen over de te nemen stappen.",
        "Alle kosten voor dierenarts, dierenkliniek, medicatie en medische behandeling tijdens het verblijf zijn voor rekening van de eigenaar."
    ]
  },
  {
    heading: "10. Gedrag en geschiktheid tijdens het verblijf",
    items: [
        "Wanneer tijdens het verblijf blijkt dat een hond niet veilig of verantwoord samen met de andere honden kan verblijven, ernstige onrust veroorzaakt of wanneer Pippaya Hondenopvang om een andere zwaarwegende reden oordeelt dat voortzetting van de opvang niet verantwoord is, mag het verblijf voortijdig worden beëindigd.",
        "De eigenaar of de opgegeven achtervang moet de hond in dat geval zo spoedig mogelijk ophalen. Het reeds betaalde bedrag voor de gereserveerde opvangperiode wordt in deze situatie niet terugbetaald, voor zover de noodzaak tot beëindiging voortvloeit uit de hond, diens gedrag of door de eigenaar niet of onjuist verstrekte informatie."
    ]
  },
  {
    heading: "11. Loopsheid en intacte reuen",
    items: [
        "Loopse teven kunnen niet bij Pippaya Hondenopvang verblijven. Wanneer een teef tijdens de gereserveerde periode loops is of naar verwachting loops zal worden, meldt de eigenaar dit zo snel mogelijk.",
        "Wordt een teef onverwacht tijdens het verblijf loops, dan beoordeelt Pippaya Hondenopvang of de opvang gezien de groepssamenstelling verantwoord kan worden voortgezet. Is dat niet mogelijk, dan moet de hond door de eigenaar of achtervang zo spoedig mogelijk worden opgehaald.",
        "Reuen zijn in principe gecastreerd of chemisch gecastreerd. Pippaya Hondenopvang kan hiervan naar eigen beoordeling afwijken bij bekende reuen waarvan uit ervaring blijkt dat zij goed in de groep functioneren."
    ]
  },
  {
    heading: "12. Wandelen, loslopen en zwemmen",
    items: [
        "De honden worden tijdens de opvang regelmatig uitgelaten en kunnen onder andere meegaan naar de polder, het bos of andere geschikte wandelplekken.",
        "De eigenaar geeft vooraf aan of de hond los mag lopen. Wanneer de eigenaar aangeeft dat dit niet is toegestaan, laat Pippaya Hondenopvang de hond niet los en wordt gebruikgemaakt van een gewone lijn of lange lijn.",
        "Wanneer de eigenaar toestemming geeft om de hond los te laten lopen, blijft Pippaya Hondenopvang per situatie beoordelen of dit veilig en verantwoord is. Toestemming van de eigenaar betekent dus niet dat de hond daadwerkelijk altijd los zal lopen.",
        "Honden kunnen tijdens wandelingen zwemmen wanneer Pippaya Hondenopvang dit verantwoord vindt. Wil de eigenaar niet dat de hond zwemt, dan moet dit vooraf duidelijk worden doorgegeven."
    ]
  },
  {
    heading: "13. Persoonlijke spullen",
    items: [
        "Iedere hond wordt gebracht met een eigen geschikte lijn en een veilige halsband en/of tuig.",
        "Een eigenaar mag daarnaast bijvoorbeeld een mand, kleed, speeltje of ander vertrouwd voorwerp meegeven. Deze spullen worden op eigen risico meegegeven. Door het verblijf met andere honden kunnen spullen vies worden, beschadigd raken of kapotgaan. Pippaya Hondenopvang is niet aansprakelijk voor schade aan of verlies van persoonlijke spullen."
    ]
  },
  {
    heading: "14. Aansprakelijkheid en schade",
    items: [
        "Pippaya Hondenopvang zorgt zo goed mogelijk voor iedere hond die hier verblijft. Toch blijven honden dieren en kunnen tijdens het spelen, wandelen of samen verblijven onverwachte situaties ontstaan.",
        "De eigenaar is verantwoordelijk voor het gedrag van de eigen hond en voor schade die de hond veroorzaakt aan andere honden, personen of eigendommen. Daarom is het belangrijk dat Pippaya vooraf op de hoogte is van bijzonderheden in het gedrag van de hond.",
        "Wanneer een hond schade veroorzaakt aan spullen van Pippaya Hondenopvang of van anderen die duidelijk verder gaat dan normale slijtage of gebruik, kunnen de kosten hiervan bij de eigenaar in rekening worden gebracht.",
        "Pippaya Hondenopvang is niet aansprakelijk voor schade die niet het gevolg is van een tekortkoming of onzorgvuldig handelen van Pippaya Hondenopvang.",
        "De eigenaar wordt geadviseerd om na te gaan of schade die door de hond wordt veroorzaakt onder de eigen aansprakelijkheidsverzekering valt."
    ]
  },
  {
    heading: "15. Verplichte achtervang en bereikbaarheid",
    items: [
        "Voor ieder verblijf regelt de eigenaar een achtervang die gedurende de volledige opvangperiode bereikbaar en beschikbaar is.",
        "De achtervang moet in staat zijn de hond zo spoedig mogelijk op te halen wanneer het verblijf onverwacht niet kan worden voortgezet, ongeacht de reden. Dit kan bijvoorbeeld nodig zijn door gedrag of ziekte van de hond, maar ook wanneer Pippaya Hondenopvang door ziekte, een ongeval of andere onverwachte omstandigheden de opvang niet kan voortzetten.",
        "De eigenaar verstrekt correcte en actuele contactgegevens van de achtervang en zorgt ervoor dat deze persoon weet dat die als achtervang is opgegeven."
    ]
  },
  {
    heading: "16. Overmacht en onverwachte uitval van Pippaya",
    items: [
        "Wanneer Pippaya Hondenopvang door ziekte, een ongeval of andere onverwachte omstandigheden tijdelijk niet in staat is de opvang zelf voort te zetten, zal Pippaya altijd eerst proberen de opvang door te laten gaan.",
        "Pippaya heeft hiervoor betrouwbare mensen in haar directe omgeving die, wanneer dat nodig en mogelijk is, kunnen helpen bij de verzorging en opvang van de honden.",
        "Mocht het ondanks deze hulp niet mogelijk zijn om de honden de opvang en verzorging te geven die zij nodig hebben, dan dient de hond door de eigenaar of de opgegeven achtervang zo spoedig mogelijk te worden opgehaald.",
        "De eigenaar betaalt in dat geval alleen voor de opvang die daadwerkelijk heeft plaatsgevonden. Is de volledige opvangperiode al betaald, dan wordt het bedrag voor de resterende opvang terugbetaald.",
        "Pippaya Hondenopvang is niet verantwoordelijk voor eventuele extra kosten die hierdoor voor de eigenaar ontstaan, zoals vervangende opvang, het wijzigen van een reis of verblijf of het eerder terugkeren van een vakantie."
    ]
  },
  {
    heading: "17. Foto’s en privacy",
    items: [
        "Tijdens de opvang maakt Pippaya Hondenopvang regelmatig foto’s en filmpjes van de honden. Deze kunnen worden gedeeld via de website en de socialmediakanalen van Pippaya Hondenopvang, waaronder Facebook en Instagram.",
        "Wil een eigenaar niet dat foto’s of filmpjes van de hond hiervoor worden gebruikt, dan kan dit vooraf of tijdens de opvang worden aangegeven. Uiteraard wordt daar rekening mee gehouden.",
        "Foto’s of filmpjes waarop eigenaren of andere personen herkenbaar in beeld zijn, worden alleen gepubliceerd wanneer daarvoor toestemming is gegeven.",
        "Persoonsgegevens van de eigenaar worden alleen gebruikt voor de opvang, communicatie en administratie van Pippaya Hondenopvang en worden niet zonder geldige reden met anderen gedeeld."
    ]
  },
  {
    heading: "18. Slotbepalingen",
    items: [
        "Op de overeenkomst is Nederlands recht van toepassing.",
        "Wanneer er een verschil van mening ontstaat, proberen Pippaya Hondenopvang en de eigenaar dit eerst samen in goed overleg op te lossen. Wanneer dat niet lukt, kunnen partijen gebruikmaken van de wettelijke mogelijkheden om het geschil op te lossen.",
        "Als een bepaling uit deze Algemene Voorwaarden niet geldig blijkt te zijn of niet kan worden toegepast, blijven de overige bepalingen zoveel mogelijk van kracht."
    ]
  }
];

export const TermsPage: React.FC = () => {
  const termsContent = (
    <>
      <Typography variant="h5" component="h2" gutterBottom>
        Algemene Voorwaarden Pippaya Hondenopvang
      </Typography>

      <Stack spacing={{ xs: 1.25, md: 1.5 }}>
        {intro.map((paragraph) => (
          <Typography key={paragraph} paragraph sx={{ mb: 0 }}>
            {paragraph}
          </Typography>
        ))}
      </Stack>

      {sections.map((section) => (
        <Box key={section.heading} sx={{ mt: 4 }}>
          <Typography variant="h6" component="h3" gutterBottom>
            {section.heading}
          </Typography>

          <Stack spacing={{ xs: 1.25, md: 1.5 }}>
            {section.items.map((item) => (
              <Typography
                key={item}
                paragraph
                sx={{
                  mb: 0,
                  ...(item.startsWith("• ")
                    ? { pl: 2.5, textIndent: "-1.25rem" }
                    : {})
                }}
              >
                {item}
              </Typography>
            ))}
          </Stack>
        </Box>
      ))}

      <Typography
        sx={{
          mt: 4,
          textAlign: "center",
          fontWeight: 700
        }}
      >
        Pippaya Hondenopvang{" "}
        <Box component="span" sx={{ color: "#D7E4C0" }}>
          ♥
        </Box>{" "}
        <Box component="span" sx={{ color: "#F8A5B6" }}>
          ♥
        </Box>
      </Typography>
    </>
  );

  return (
    <LegalPage
      title="Algemene Voorwaarden"
      lastUpdated="1 oktober 2026"
      content={termsContent}
    />
  );
};
